import React from "react";
import { Outlet, Navigate, Route, Routes, useLocation } from "react-router-dom";
import Home from "../pages/home";
import Header from "../inc/Header";
import Footer from "../inc/Footer";
import ProjectManagementAllSoftware from "../pages/products/projectmanagementallsoftware";
import ProductDetails from "../pages/products/productdetails";
import CommunityDetails from "../pages/products/community";
import Disputes from "../pages/products/disputes";
import ProductComparision from "../pages/products/productcomparision";
import ScrollToTop from "../components/ScrollToTop"; // Import the ScrollToTop component
import Solutions from "pages/solutions";
import Resources from "pages/resources";
import ResourcesDetails from "pages/resources/resourcedetails";
import ResourcesAll from "pages/resources/resourcesall";
import ScrollToTopSection from "components/ScrollToTopSection";
import AboutUs from "pages/aboutus";
import WriteAReview from "pages/writeareview";
import MyProfile from "pages/profile/myprofile";
import VendorRoutes from "./VendorRoutes";
import ProfilePublic from "pages/profile/profilepublic";
import Software from "pages/software";
import ClientSideProtectionSolutions from "pages/products/clientsideprotectionsolutions";
import SolutionProductDetails from "pages/products/productdetails/SolutionProductDetails";
import TermsConditions from "pages/legal/terms-conditons";
import PrivacyPolicy from "pages/legal/privacy-policy";
import ReturnPolicy from "pages/legal/return-policy";
import ResetPassword from "pages/auth/resetpassword";
import { useAuth } from "context/UserContext";
import AuthRedirect from "pages/auth/authRedirect";
import ErrorPage from "pages/error";
import ReviewComment from "pages/reviewcomment"
import { toast } from "react-toastify";
const ProtectedRoute = ({ children, allowVendor = false }) => {
  const { isLoggedIn, user, wasLoggedIn } = useAuth();
  const location = useLocation();
  console.log('location', location)
  if (!isLoggedIn) {
    if (!wasLoggedIn) {
      toast.error("Please login to access this page", {
        toastId: "login-required"
      });
    }
    if(location.pathname === "/write-a-review"){
      return <Navigate to={location.state?.from || "/"} />;
    }
    return <Navigate to={"/"} />;
  }

  if (user?.role !== "user" && !allowVendor) {
    toast.error("You are not authorized to access this page", {
      toastId: "unauthorized"
    });
    return <Navigate to={location.pathname || "/"}/>;
  }

  return children;
};
// const PublicRoute = ({ children }) => {
//   const { isAuthenticated } = useAuthStore();
//   console.log('isAuthenticated', isAuthenticated)
//   return isAuthenticated ? <Navigate to="/dashboard" /> : children;
// };
const Layout = () => (
  <>
    <ScrollToTop />
    <Header />
    <Outlet />
    <Footer />
    <ScrollToTopSection />
  </>
);
function WebRoutes() {

  return (

    <>
      <Routes>
        <Route element={<Layout />}>
          <Route exact path="/" element={<Home />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route
            path="/:category/:slug"
            element={<ProjectManagementAllSoftware />}
          />
          <Route
            path="/solution-product-details"
            element={<SolutionProductDetails />}
          />
          <Route
            path="/client-side-protection-solutions"
            element={<ClientSideProtectionSolutions />}
          />
          <Route path="/product-details/:slug" element={<ProductDetails />} />
          <Route
            path="/community"
            element={
              <ProtectedRoute allowVendor={true}>
                <CommunityDetails />
              </ProtectedRoute>
            }
          />
          <Route path="/disputes" element={<Disputes />} />
          <Route path="/product-comparision" element={<ProductComparision />} />
          <Route path="/solutions" element={<Solutions />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/resources-all/:id" element={<ResourcesAll />} />
          <Route path="/resources-details/:id" element={<ResourcesDetails />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/write-a-review" element={
            <ProtectedRoute >
              <WriteAReview />
            </ProtectedRoute>
          } />
          <Route
            path="/my-profile"
            element={
              <ProtectedRoute>
                <MyProfile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/review-comment/:slug"
            element={
              <ProtectedRoute allowVendor={true}>
                <ReviewComment />
              </ProtectedRoute>
            }
          />
          <Route
            path="/public-profile/:id"
            element={
              // <ProtectedRoute>
                <ProfilePublic />
              // </ProtectedRoute>
            }
          />
          <Route path="/software" element={<Software />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/return-policy" element={<ReturnPolicy />} />
          <Route path="/auth-redirect" element={<AuthRedirect />} />
          <Route path="/error" element={<ErrorPage />} />
          <Route path="/vendor/*" element={<VendorRoutes />} />
          <Route path="*" element={<Navigate to="/error?message=Oops! Page Not Found" replace />} />
        </Route>
      </Routes>

    </>
  );
}

export default WebRoutes;
